export default __webpack_public_path__ + "static/media/bedroom4.648fa244.webp";